import dayjs from 'dayjs';

const getDateOfMonth = (date: Date | string): number => dayjs(date).date();

export { getDateOfMonth };
